import { Route, Routes } from "react-router";
import { NotFound } from "../../../app/pages/NotFound";
import { WILDCARD_ROUTE } from "../../../common/constants";
import { Permission } from "../../../common/security/enums";
import PageWithPermission from "../../auth/components/PageWithPermission";
import { CommissionsSettingsRanksListContainer } from "./components/containers/CommissionsSettingsRanksListContainer";

export const CommissionsSettingsRanksRoutes = () => (
  <Routes>
    <Route
      index
      element={
        <PageWithPermission
          component={<CommissionsSettingsRanksListContainer />}
          permissions={[Permission.TOP_AGENT_COMMISSIONS]}
        />
      }
    />

    <Route path={WILDCARD_ROUTE} element={<NotFound />} />
  </Routes>
);
